import axios from '@/services'

export default {
  registerResident: async (data, registrationToken) =>
    await axios.post('/api/user/individual/resident/register/' + registrationToken, data)
}
